import { gql } from '@apollo/client'
import { useSafeRunMutation } from 'utils/mutations'

const mutation = gql`
  mutation facilityConfirmProfile($id: ID!, $delete: Boolean) {
    facilityConfirmProfile(id: $id, delete: $delete) {
      id
      confirmed
      confirmed_at
      confirmed_by {
        full_name
      }
    }
  }
`

export default function useFacilityConfirmProfile() {
  const { onMutate: onFacilityConfirmProfile, loading } = useSafeRunMutation({
    mutation,
    responsePath: 'facilityConfirmProfile',
    successMessage: 'Facility confirmed'
  })

  return { onFacilityConfirmProfile, loading }
}
